<template>
  <div class="home-container">
    <!-- 可视化模式 -->
    <div class="container-head" :class="{ headEdit: isEdit }">
      <div class="head-title">
        {{ !isEdit ? "可视化模式" : "可视化编辑模式" }}
      </div>
      <!-- <div class="home-edit" v-show="isEdit" @click="editFn"></div> -->
      <!-- 设备信息 -->
      <home-info :infoData="infoList" :key="infoList.name"></home-info>
    </div>
    <!-- 多选列表 -->
    <machine-list-tip
      v-show="isEditListShow && isEdit"
      :isParameter="true"
      :maxCheck="12"
      :minCheck="6"
      :machineData="machineData"
      @child-closeFn="closeFn"
    ></machine-list-tip>
  </div>
</template>
<script>
// api接口
import {machineList } from "@/assets/api/chartData";
import homeInfo from "@/module/homeInfo.vue";
import machineListTip from "@/module/machineListTip.vue";
export default {
  props: ["isHomeEdit"],
  components: {
    homeInfo,
    machineListTip,
  },
  data() {
    return {
      // 设备信息
      infoList:{
        name:'',
        list:[]
      },
      isEdit: false,
      machineData: {
        name: "生产线参数",
        list: [
          {
            name: "当日投入粉体总量",
            key: "touru",
            type: 1,
            value: "280kg",
          },
          {
            name: "日产能预算",
            key: "yusuan",
            type: 1,
            value: "8453 件",
          },
          {
            name: "总功率",
            key: "zong",
            type: 1,
            value: "900 kw",
          },
          {
            name: "工作中",
            key: "work",
            type: 1,
            value: "280",
          },
          {
            name: "工作中",
            key: "work1",
            type: 1,
            value: "280",
          },
          {
            name: "工作中",
            key: "work2",
            type: 1,
            value: "280",
          },
          {
            name: "工作中",
            key: "work3",
            type: 1,
            value: "280",
          },
          {
            name: "工作中",
            key: "work4",
            type: 1,
            value: "280",
          },
          {
            name: "工作中",
            key: "work5",
            type: 1,
            value: "280",
          },
          {
            name: "工作中",
            key: "work6",
            type: 0,
            value: "280",
          },
          {
            name: "工作中",
            key: "work11",
            type: 0,
            value: "280",
          },
          {
            name: "工作中",
            key: "work21",
            type: 0,
            value: "280",
          },
          {
            name: "工作中",
            key: "work31",
            type: 0,
            value: "280",
          },
          {
            name: "工作中",
            key: "work41",
            type: 0,
            value: "280",
          },
          {
            name: "工作中",
            key: "work51",
            type: 0,
            value: "280",
          },
          {
            name: "工作中",
            key: "work61",
            type: 0,
            value: "280",
          },
        ],
      },
      isEditListShow: false,
      getDataInterval: null,
    };
  },
  created(){
    this.getMachineList();
  },
  mounted() {
     this.getDataInterval = setInterval(() => {
        this.getMachineList();
    },5000)
  },
  methods: {
   async getMachineList() {
      let res = await machineList();
      this.infoList = res.data.indexPageFileds;
      let data = res.data.dieCuttingFileds.filedVoList[3];
      let data2 = res.data.dieCuttingFileds.filedVoList[4];
      let data3 = res.data.dieCuttingFileds.filedVoList[1];
      this.infoList.filedVoList.push(data,data2,data3);
      // console.log(res.data);
    },
    editFn() {
      this.isEditListShow = true;
    },
    // 子组件关闭按钮
    closeFn() {
      this.isEditListShow = false;
    },
  },
  watch: {
    isHomeEdit(n) {
      this.isEdit = n;
    },
  },
  destroyed(){
    //清除定时器
    if (this.getDataInterval)  clearInterval(this.getDataInterval);
  }
};
</script>
<style lang="less" scoped>
.home-container {
  display: flex;

  .container-head {
    width: 993.6px;
    height: 185.6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url("./images/container-head-bg.png") no-repeat 0 0;
    background-size: 100% 100%;
    position: relative;

    .head-title {
      width: 100%;
      height: 32px;
      font-size: 20.8px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      line-height: 32px;
      text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
    }

    .home-edit {
      width: 28.8px;
      height: 28.8px;
      background: url("./images/edit.png") no-repeat 0 0;
      background-size: 100% 100%;
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
    }

    .head-info {
      width: 100%;
      height: 56px;
      margin-top: 16px;
      padding: 0 9.6px;
      user-select: text;
    }
  }

  .headEdit {
    background: url("./images/container-head-bg.png") no-repeat 0 0;
    background-size: 100% 100%;
  }

  .machineListTip {
    margin-left: 10px;
  }
}
</style>